module.exports = __webpack_public_path__ + "img/svg/background-messages.dd1bf89decb94b6966b5282a5111d686.svg";